import { Button, Space } from 'antd';
import { isEqual } from 'lodash-es';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';

import {
  SubmitButton,
  useFormContext,
} from '../../../../components/forms/forms';
import { cssVariables } from '../../../../styles/cssVariables';
import { pxToNumber } from '../../../../utils/cssUtils';

export default function AdminAccountProfileButtons({
  viewMode,
  setViewMode,
  initialValues,
  sectionHomeRoute,
  formToGraphql,
}) {
  const { values, formInstance, forceUpdate, triggerSubmit } = useFormContext();
  const { push } = useHistory();
  const isChanged = !isEqual(
    formToGraphql(values),
    formToGraphql(initialValues)
  );

  return (
    <Space direction="horizontal" size={pxToNumber(cssVariables.spaceNorm)}>
      <Button
        ghost
        size="middle"
        className="width-70"
        onClick={() => {
          if (viewMode) {
            push(sectionHomeRoute);
          } else {
            formInstance.setFieldsValue(initialValues);
            forceUpdate();
            setViewMode(true);
          }
        }}
      >
        <FormattedMessage id="buttons.cancel" />
      </Button>
      {viewMode ? (
        <Button
          type="primary"
          size="middle"
          className="width-70"
          onClick={() => setViewMode(false)}
        >
          <FormattedMessage id="buttons.edit" />
        </Button>
      ) : (
        <SubmitButton
          type="primary"
          size="middle"
          className="width-70"
          disabled={!isChanged}
          onClick={triggerSubmit}
        >
          <FormattedMessage id="buttons.save" />
        </SubmitButton>
      )}
    </Space>
  );
}
